/* eslint-disable indent */
import "babel-polyfill";

import {binder} from "./libs/binder";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/slick.js";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {headerSearch} from "./modules/headerSearch";
import {footerDropDown} from "./modules/footerDropDown";
import {toggleTabs} from "./modules/tabs";
import {animationOnScroll} from "./modules/animations";
import {accordion} from "./modules/accordion";
import {customSelect} from "./modules/customSelect";
import {toggleBlockShow} from "./modules/toggleBlockShow";
import {showPopUp} from "./modules/popUp";
import {sideSlider, awardsSlider, testimonialsSlider} from "./modules/slider";
import {mapSection} from "./modules/mapSection";
import {videoModal} from "./modules/videoModal";
import {testimonialHomeSlider} from "./modules/testimonialHomeSlider";
import {activeOnScroll} from "./modules/scrollActive";
import {chartWithToggle} from "./modules/chartWithToggle";
import {treeMap} from "./modules/treeMap";
import {youtubePlaylistSlider} from "./modules/youtubePlaylistSlider";
// import { hidePopUpViaWrapper } from "./modules/hidePopUpViaWrapper";
import {showResults} from "./modules/showResults";
import {inquiryForm} from "./modules/inquiryForm";
import {portfolioFilteredScroll} from "./modules/portfolioFilteredScroll";
import {faqSearchScroll} from "./modules/faqSearchScroll";
import {stepsScroll} from "./modules/stepsScroll";
import {heroForm} from "./modules/heroForm";

binder({
    bounds: {
        html: [constants, fullHeightPage],
        ".header": [stickyHeader, mobileNav, headerSearch],
        ".footer": footerDropDown,
        ".has-animation": animationOnScroll,
        ".tabs-box": toggleTabs,
        ".accordion": accordion,
        "select": customSelect,
        ".show-private-info": toggleBlockShow,
        ".open-pop-up": showPopUp,
        // ".close-pop-up": hidePopUp,
        // ".pop-up-info": [hidePopUp, hidePopUpViaWrapper],
        ".side-by-side-slider": sideSlider,
        ".awards-slider": awardsSlider,
        ".map-frame": mapSection,
        ".playlist-slider": youtubePlaylistSlider,
        // ".home-chart": charts,
        ".testimonials-slider": testimonialsSlider,
        ".testimonial-home-slider": testimonialHomeSlider,
        ".faqs-box": [activeOnScroll, faqSearchScroll],
        ".market-growth-chart": chartWithToggle,
        ".diversification-section": treeMap,
        ".faqs-wrapper": showResults,
        ".inquiry-form": inquiryForm,
        ".property-listing": portfolioFilteredScroll,
        ".get-started-steps": stepsScroll,
        ".hero-section.with-form": heroForm
        // ".video-pop-up": videoModal,
    },
    runTests: false,
});



// WEBPACK FOOTER //
// ./assets/js/global.js